import React from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '../../../../lib/utils'

// Compact pill toggle for the global Analysis time range. "Phase" only
// appears when there's a current phase to anchor it to — without one
// the button has no meaningful date anchor.
const STATIC_RANGES = ['7d', '30d', '90d']

export function AnalysisRangePicker({ value, onChange, hasPhase }) {
  const { t } = useTranslation()

  const options = hasPhase ? [...STATIC_RANGES, 'phase'] : STATIC_RANGES

  return (
    <div className="flex gap-1" role="radiogroup" aria-label={t('phoenixTracker.analysis.rangeAria')}>
      {options.map((r) => (
        <button
          key={r}
          type="button"
          role="radio"
          aria-checked={value === r}
          onClick={() => onChange(r)}
          className={cn(
            'px-2.5 py-1 rounded-md text-[11px] font-medium font-mono transition-colors',
            value === r
              ? 'bg-app-primary-500 text-white'
              : 'bg-muted text-muted-foreground hover:bg-accent hover:text-foreground'
          )}
          dir="auto"
        >
          {r === 'phase' ? t('phoenixTracker.analysis.range.phase') : r}
        </button>
      ))}
    </div>
  )
}
